import React, { Component } from "react";
import { Layout, Button, Col, Row, Space, Popconfirm, Card, Typography, List, Menu, Dropdown, message, Tag, Tooltip, Empty } from "antd";

import { GoFileCode } from "react-icons/go";
import { FilePdfOutlined,  EyeFilled, EditFilled, DeleteFilled, CloseCircleOutlined, DownloadOutlined } from "@ant-design/icons";

//componentes
import FloatingButton from "../../../Widgets/Floating Button/FloatingButton";
import { IconDetails, IconEdit, IconDelete, IconSAT } from '../../../Widgets/Iconos';
import { RenderTagTipoComprobanteFactura } from "../../../Utils";

//Modales
import ModalFacturas from "./ModalFacturas"
import ModalFacturasDetalle from "./ModalFacturasDetalle"
import ModalCancelacion from "../../Finanzas/Facturas/ModalCancelacion"
import DrawerTimbradoOrden from "../../Finanzas/Facturas/DrawerTimbrado"


const { Content } = Layout;
const { Text, Title } = Typography
const axios = require('axios')
const moment = require('moment')

/**
 * @export
 * @class EgresosList
 * @extends {Component}
 * @description Vista de Project Manager
 */
export default class EgresosList extends Component {


    constructor(props) {
        super(props)
        this.state = {
            facturas: [],
            page: 1,
            limit: 10,
            total: 0,
            transaccion_id: undefined,
            modalTransaccionEgreso: false,
            visibleDrawerTimbradoOrden: false,
            filtroSearch: '',
            searching: true,

        }
    }

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        this.getFacturas()
    }


    componentDidUpdate = (prevProps) => {

        console.log(this.props)

        const filtro = this.state.filtroSearch;
        const propFiltro = this.props.search;

        if (filtro !== propFiltro && this.state.searching == true) {
            this.getFacturas();
            this.state.searching = false;
        }

        //si cambia la orden, actualiza las facturas
        if (this.props.orden_id && this.props.orden_id !== prevProps.orden_id) {
            this.getFacturas(1)
        }
    }

    /**
    *
    *
    * @memberof AccountPurchases
    * @method getFacturas
    * @description Obtiene las facturas de la orden acual
    */
    getFacturas = (page = 1) => {
        let search = this.props.search;
        const { tipo } = this.state;
        const { orden_id } = this.props;
        if (!orden_id) return;

        axios.get('/facturas/list', {
            params: {
                id: orden_id,
                tipo,
                page: page,
                search

            },
        })
            .then(({ data }) => {
                this.setState({
                    facturas: data.data.itemsList,
                    total: data.data.paginator.itemCount,
                    page: data.data.paginator.currentPage,

                    searching: true,
                    filtroSearch: search
                })
            })
            .catch(err => console.log(err))
    }

    /**
     *
     *
     * @memberof AccountPurchases
     * @method deleteItem
     * @description Elimina una factura
     */
    deleteItem = (id) => {

        axios.post('/facturas/delete', {
            id
        }).then(response => {
            this.getFacturas();
            this.props.updateOrden()
            message.success('Factura Eliminada')
        }).catch(err => {
            console.log(err)
            message.error('Error al eliminar la factura')
        })
    }


    /**
     * @memberof EgresosList
     * @method renderTipo
     * @description Tag del tipo de afectacion de la factura
     */
    renderTipo = (item) => {
        if (item.tipo === -1) return <Tag color="volcano" style={{ margin: 0 }}>Egreso</Tag>
        if (item.tipo === 0) return <Tag style={{ margin: 0 }}>Sin Cambios</Tag>
        return <Tag color="green" style={{ margin: 0 }}>Ingreso</Tag>
    }

    /**
     * @memberof EgresosList
     * @method renderDato
     * @description Bloque etiqueta / valor usado en el detalle de la factura
     */
    renderDato = (label, value, extra) => <div>
        <Text className="text-gray" style={{ display: 'block', fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.5 }}>{label}</Text>
        <Text strong style={{ display: 'block', fontSize: 13 }} ellipsis={typeof value === "string" ? { tooltip: value } : false}>{value ?? '-'}</Text>
        {extra ? <Text type="secondary" style={{ display: 'block', fontSize: 11 }}>{extra}</Text> : null}
    </div>

    /**
     *
     *
     * @return {*}
     * @memberof EgresosList
     */
    render() {

        return (
            <>
                <Content>
                    <List
                        className="component-list"
                        dataSource={this.state.facturas}
                        locale={{
                            emptyText: <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description="Esta orden no tiene facturas registradas"
                            />
                        }}
                        pagination={{
                            current: this.state.page,
                            pageSize: this.state.limit,
                            total: this.state.total,
                            hideOnSinglePage: true,
                            position: 'bottom',
                            className: "flex-left",
                            onChange: this.getFacturas,
                        }}
                        renderItem={item => {

                            const monto = item.monto ?? 0
                            const timbrada = item.tipo_facturacion === 1
                            const cancelada = item.estatus === 0

                            return <List.Item className="component-list-item">
                                <Card
                                    className="card-list"
                                    bodyStyle={{ padding: 0 }}
                                >
                                    <Row>
                                        {/* Informacion de la factura */}
                                        <Col xs={24} lg={17} style={{ padding: '16px 20px' }}>

                                            <Space size={8} wrap align="center" style={{ marginBottom: 4 }}>
                                                <Title level={5} style={{ margin: 0 }}>
                                                    {item.concepto || 'Factura sin concepto'}
                                                </Title>
                                                {(item.serie || item.folio) ? <Text type="secondary">{item.serie}-{item.folio}</Text> : null}
                                                {RenderTagTipoComprobanteFactura(item.tipo_comprobante)}
                                                {cancelada ? <Tag color="red" style={{ margin: 0 }}>Cancelada</Tag> : null}
                                            </Space>

                                            <div style={{ marginBottom: 12 }}>
                                                {item.uuid
                                                    ? <Text copyable={{ text: item.uuid }} type="secondary" style={{ fontSize: 11 }}>UUID: {item.uuid}</Text>
                                                    : <Text type="secondary" style={{ fontSize: 11 }}>Sin UUID (no timbrada ante el SAT)</Text>}
                                            </div>

                                            <Row gutter={[16, 12]}>
                                                <Col xs={12} md={5}>
                                                    {this.renderDato('Fecha', moment(item.fecha_vigencia).format('DD/MM/YYYY'))}
                                                </Col>
                                                <Col xs={12} md={7}>
                                                    {this.renderDato('Emisor', item.emisor?.nombre, item.emisor?.rfc)}
                                                </Col>
                                                <Col xs={12} md={7}>
                                                    {this.renderDato('Receptor', item.receptor?.nombre, item.receptor?.rfc)}
                                                </Col>
                                                <Col xs={12} md={5}>
                                                    {this.renderDato('Monto', <>$ {monto.toMoney(true)} <small>MXN</small></>)}
                                                </Col>
                                            </Row>
                                        </Col>

                                        {/* Acciones */}
                                        <Col
                                            xs={24} lg={7}
                                            style={{
                                                padding: '16px 20px',
                                                borderLeft: '1px solid #f0f0f0',
                                                background: '#fafafa',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <Text className="text-gray" style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>Acciones</Text>

                                            <Space direction="vertical" size={8} className="width-100">
                                                <Button
                                                    block
                                                    icon={<EyeFilled />}
                                                    onClick={() => this.setState({
                                                        modalFacturaDetalleVisible: true,
                                                        factura_id: item._id
                                                    })}
                                                >Ver Detalle</Button>

                                                <Button
                                                    block
                                                    type="primary"
                                                    icon={<EditFilled />}
                                                    onClick={() => this.setState({
                                                        modalFacturaVisible: true,
                                                        factura_id: item._id
                                                    })}
                                                >Editar</Button>

                                                <Space size={8} className="width-100">
                                                    <Tooltip title={timbrada ? "Ver PDF del CFDI" : "Disponible solo para facturas timbradas"}>
                                                        <Button
                                                            icon={<FilePdfOutlined />}
                                                            disabled={!timbrada}
                                                            onClick={() => window.open(`${axios.defaults.baseURL}/facturas/cfdi?factura_id=${item._id}&Authorization=${sessionStorage.getItem("token")}`, '_blank')}
                                                        >PDF</Button>
                                                    </Tooltip>

                                                    <Tooltip title={(typeof item?.factura_xml === "string") ? "Descargar XML" : "Esta factura no tiene XML"}>
                                                        <Button
                                                            icon={<GoFileCode style={{ position: "relative", top: 2 }} />}
                                                            disabled={!(typeof item?.factura_xml === "string")}
                                                            download={true}
                                                            href={(typeof item?.factura_xml === "string")
                                                                ? `${axios.defaults.baseURL}/facturas/cfdi/xml?factura_id=${item._id}&Authorization=${sessionStorage.getItem("token")}&dummy=dummy`
                                                                : undefined}
                                                        > XML</Button>
                                                    </Tooltip>

                                                    {cancelada
                                                    ? <Tooltip title="Descargar acuse de cancelación del SAT">
                                                        <Button
                                                            icon={<DownloadOutlined />}
                                                            onClick={() => window.open(`${axios.defaults.baseURL}/facturas/cancelacion/xml?factura_id=${item._id}&Authorization=${sessionStorage.getItem("token")}`, '_blank')}
                                                        >Acuse de Cancelación</Button>
                                                    </Tooltip>
                                                    : <Tooltip title={item.estatus === 1 ? "Cancelar la factura ante el SAT" : "Solo se pueden cancelar facturas timbradas"}>
                                                        <Button
                                                            danger
                                                            type="primary"
                                                            icon={<CloseCircleOutlined />}
                                                            disabled={!(item.estatus === 1)}
                                                            onClick={() => this.setState({
                                                                modalCancelacionVisible: true,
                                                                factura_id: item._id
                                                            })}
                                                        />
                                                    </Tooltip>}

                                                    <Popconfirm
                                                        placement="topRight"
                                                        title={<>
                                                            ¿Deseas eliminar este registro?
                                                            <br /> ELIMINARLO NO LO CANCELARÁ DEL SAT
                                                        </>}
                                                        okText="Si"
                                                        cancelText="No"
                                                        onConfirm={() => this.deleteItem(item._id)}
                                                    >
                                                        <Tooltip title="Eliminar factura">
                                                            <Button danger icon={<DeleteFilled />} />
                                                        </Tooltip>
                                                    </Popconfirm>
                                                </Space>
                                            </Space>
                                        </Col>
                                    </Row>
                                </Card>
                            </List.Item>
                        }}
                    />

                </Content>
                <ModalFacturas
                    visible={this.state.modalFacturaVisible}
                    factura_id={this.state.factura_id}
                    onClose={() => {
                        this.setState({ modalFacturaVisible: false, factura_id: undefined });
                        this.getFacturas();
                    }}
                    orden={this.props.orden}
                />
                <ModalFacturasDetalle
                    visible={this.state.modalFacturaDetalleVisible}
                    factura_id={this.state.factura_id}
                    onClose={() => {
                        this.setState({ modalFacturaDetalleVisible: false, factura_id: undefined });
                        this.getFacturas();
                    }}
                    orden={this.props.orden}
                />

                <ModalCancelacion
                    visible={this.state.modalCancelacionVisible}
                    factura_id={this.state.factura_id}
                    onClose={() => {
                        this.setState({ modalCancelacionVisible: false, factura_id: undefined });
                        this.getFacturas();
                        this.props.updateOrden?.();
                    }}
                />

                <DrawerTimbradoOrden
                    visible={this.state.visibleDrawerTimbradoOrden}
                    orden_id={this.props.orden_id}
                    onClose={() => {
                        this.setState({ visibleDrawerTimbradoOrden: false })
                    }}
                    onSuccess={() => {
                        this.setState({ visibleDrawerTimbradoOrden: false })
                        this.getFacturas()
                    }}
                />
                {/*  */}
                <FloatingButton
                    placement="topRight"
                    arrow
                    onClick={() => this.setState({ visibleDrawerTimbradoOrden: true })} 
                    title="Opciones de Facturas" />


            </>
        )
    }
}